import { render, staticRenderFns } from "./DashboardConnections.vue?vue&type=template&id=1ae490bc"
import script from "./DashboardConnections.vue?vue&type=script&lang=js"
export * from "./DashboardConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports